import React from 'react';
import { Modal, Button, CircularLoader } from 'utils';
import {getFormattedDateTime} from '../Utilities';
import styles from './gift-card.module.scss';

function CardDetailModal({
    gcOrderDetail,
    onClose
}) {

    function renderContent() {
        var giftcards = [];
        for (let i = 0; i < gcOrderDetail.cards.length; i++) {
            giftcards.push(
                <div  className={styles.item}>
                    <p><span>{gcOrderDetail.cards[i].cardNumber}</span><img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={()=>{
                                            var textField = document.createElement('textarea');
                                            textField.innerText = gcOrderDetail.cards[i].cardNumber;
                                            document.body.appendChild(textField);
                                            textField.select();
                                            document.execCommand('copy');
                                            textField.remove();
                                        }}
                                    /></p>
                    <p><span className="blur_text">{gcOrderDetail.cards[i].cardPin}</span><img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={()=>{
                                            var textField = document.createElement('textarea');
                                            textField.innerText = gcOrderDetail.cards[i].cardPin;
                                            document.body.appendChild(textField);
                                            textField.select();
                                            document.execCommand('copy');
                                            textField.remove();
                                        }}
                                    /></p>
                </div>
            )
        }
            return (
                <>
                    <div className={styles.carddeatils}>
                    <div className={styles.heading}>
                    <p className={styles.productName}>{gcOrderDetail.productName}</p>
                    <p className={styles.productAmount}>worth ₹ {parseFloat(gcOrderDetail.amount).toFixed(2)}</p>
                    <p className={styles.productValidity}>Validity: {getFormattedDateTime(gcOrderDetail.cards[0].validity)}</p>
                    </div>
                    <div className={styles.cards}>
                    <div  className={styles.item}>
                    <p>Card Number</p>
                    <p>Card Pin</p>
                    </div>
                            {giftcards}
                    </div>
                    <p className={styles.btn_box}>
                    <Button
                        label="Go Back"
                        className={styles.button}
                        width={200}
                        onClick={onClose}
                    />
                    </p>
                </div>
                </>
            );
        
    }

    return (
        <Modal
            classname={styles.cardmodal}
            onClose={onClose}
        >
            {renderContent()}
        </Modal>
    );
}

export default CardDetailModal;
